import React from "react";
import PropTypes from "prop-types";

import { UINumberField, UISelect, UITextField } from "../../../../../ui";
import { getVisibleError } from "../helpers";
import { useSelector } from "react-redux";
import messages from "../../../../../../assets/locale/messages";

const RoleFields = ({
  formik,
  role,
  roleIndex,
  options,
}) => {
  const lang = useSelector((state) => state.locale.lang);
  const { events } = messages[lang];
  const t = events?.creatEvent?.defineRolesAndShifts;
  const selectedRoleIds = formik.values.event_roles_attributes
    .map((item, index) => (index === roleIndex ? null : item.role_id))
    .filter(
      (id) => id !== null && id !== undefined && id !== "",
    )
    .map(String);
  const availableOptions = options.filter(
    (option) => !selectedRoleIds.includes(String(option.id)),
  );

  return(
  <div className="roles-field-grid roles-field-grid--four">
   
    <UISelect
      label={t.roleName}
      name={`event_roles_attributes.${roleIndex}.role_id`}
      placeholder={t.roleNamePlaceholder}
      required
      options={availableOptions}
      isOptionEqualToValue={(option, selected) =>
        option != null &&
        selected != null &&
        String(option.id) === String(selected.id)
      }
      value={
        options.find((option) => String(option.id) === String(role.role_id)) ||
        null
      }
      onChange={(option) => {
        const id =
          option?.id === null || option?.id === undefined ? "" : option.id;
        const nameStr = option?.name ?? "";
        const roles = [...formik.values.event_roles_attributes];
        roles[roleIndex] = {
          ...roles[roleIndex],
          role_id: id,
          role_name: nameStr,
        };
        formik.setFieldValue("event_roles_attributes", roles, true);
        formik.setFieldTouched(
          `event_roles_attributes.${roleIndex}.role_id`,
          true,
          false,
        );
      }}
      helperText={getVisibleError(
        formik,
        `event_roles_attributes.${roleIndex}.role_id`,
      )}
    />
    <UINumberField
      label={t.numberOfMales}
      name={`event_roles_attributes.${roleIndex}.maximum_number_of_males`}
      placeholder={t.numberOfMalesPlaceholder}
      required
      min={1}
      step={1}
      helperText={getVisibleError(
        formik,
        `event_roles_attributes.${roleIndex}.maximum_number_of_males`,
      )}
    />
    <UINumberField
      label={t.numberOfFemales}
      name={`event_roles_attributes.${roleIndex}.maximum_number_of_females`}
      placeholder={t.numberOfFemalesPlaceholder}
      required
      min={1}
      step={1}
      helperText={getVisibleError(
        formik,
        `event_roles_attributes.${roleIndex}.maximum_number_of_females`,
      )}
    />
    <UITextField
      label={t.uniformCode}
      name={`event_roles_attributes.${roleIndex}.uniform_code`}
      placeholder={t.uniformCodePlaceholder}
      helperText={getVisibleError(
        formik,
        `event_roles_attributes.${roleIndex}.uniform_code`,
      )}
    />
  </div>
)};

RoleFields.propTypes = {
  formik: PropTypes.object.isRequired,
  role: PropTypes.object.isRequired,
  roleIndex: PropTypes.number.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
};

RoleFields.defaultProps = {
  options: [],
};

export default RoleFields;
